import React, { useState } from 'react';
import { EaseDrawer } from '../../../libs/EaseDrawer';
import { Alert, Badge, Button, Descriptions } from 'antd';
import { alertify, handleApiExceptions, printRupee } from '../../../app_methods';
import { PermissionHoc } from "../../HOC";
import { Text1, Text3, Text4, Text5 } from '../../../styles';
import moment from 'moment';
import { AccountModal } from './accounts_modal'
import { STATUSTYPES } from './constants'
import { constant } from 'lodash';
import { PaymentAttemptsDrawer } from './payment_attempts_drawer';
import { connect } from 'react-redux';
import { updateCurrentUserAction } from '../../../redux/actions';

const GSTDetailsRdx = (props) => {
    const gst = props.gst || {};
    let user = props.user.user ? props.user.user : ''
    const [isPaying, setIsPaying] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [showVirtualAccountModal, setShowVirtualAccountModal] = useState(false);
    const [isUpdatingSA, setIsUpdatingSA] = useState(false);
    const [showPaymentAttemptsDrawer, setShowPaymentAttemptsDrawer] = useState(false);

    const PermissableButton = PermissionHoc(Button, null, { is_component: true, fallbackComponent: null })

    const processPayment = async (virtual_account_id) => {
        setIsPaying(true);
        if (virtual_account_id == '') {
            setIsPaying(false);
            alertify('Error', "Please select source account.", 'error');
            return;
        }
        const response = await gst.processPayment({ id: gst.id, virtual_account_id: virtual_account_id });
        if (!response.success) {
            handleApiExceptions(response);
            setIsPaying(false);
            props.fetchChallanList();
            setShowVirtualAccountModal(false);
            return;
        }
        props.fetchChallanList();
        setIsPaying(false);
        setShowVirtualAccountModal(false)
    }

    const downloadAdvice = async () => {
        setIsDownloading(true);
        const response = await gst.downloadAdvice();
        if (!response.success) {
            setIsDownloading(false);
            handleApiExceptions(response);
            return;
        }
        window.open(response.data.url, "_blank");
        setIsDownloading(false);
    }

    const toggleVirtualAccountModal = (is_edit = false) => {
        setIsUpdatingSA(is_edit);
        setShowVirtualAccountModal(!showVirtualAccountModal)
    }

    const togglePaymentAttemptsDrawer = () => {
        setShowPaymentAttemptsDrawer(!showPaymentAttemptsDrawer);
    }

    const PayNowButton = PermissionHoc(Button, "GST_CHALLAN_WRITE", {
        is_component: true,
        fallbackComponent: '---',
    });

    const ApproveButton = PermissionHoc(Button, "GST_CHALLAN_WRITE", {
        is_component: true,
        fallbackComponent: '---',
    });

    const approvePayment = async () => {
        setIsPaying(true);
        let approval_id = gst.current_challan_approval.id
        const response = await gst.approvePayment({ approval_id });
        if (!response.success) {
            setIsPaying(false);
            props.fetchChallanList();
            handleApiExceptions(response);
            return;
        }
        props.fetchChallanList();
        setIsPaying(false);
    }
    const renderTitle = () => {
        return (
            <div className="mb-4">
                <Text1 className="d-block" strong>Challan Details</Text1>
                <Text5 copyable>{gst.id}</Text5>
            </div>
        )
    };

    const renderBasicDetails = () => {
        return (
            <div className="mt-4">
                <Text3 className="d-block" strong>Basic Details</Text3>
                <Descriptions className='mt-2' title={false} column={1} bordered size="small">
                    <Descriptions.Item label="GSTIN">{gst.gstin}</Descriptions.Item>
                    <Descriptions.Item label="CPIN">{gst.cpin}</Descriptions.Item>
                    <Descriptions.Item label="Due Date">{gst.expiry_date && moment(gst.expiry_date).format("LL")}</Descriptions.Item>
                </Descriptions>
            </div>
        )
    }

    const renderPaymentDetails = () => {
        return (
            <div className="mt-4">
                <Text3 className="d-block" strong>Payment Details</Text3>
                <Descriptions className='mt-2' title={false} column={1} bordered size="small">
                    <Descriptions.Item label="Total GST"><strong>{printRupee(gst.total_amount)}</strong></Descriptions.Item>
                    <Descriptions.Item label="CGST">{printRupee(gst.cgst_amount)}</Descriptions.Item>
                    <Descriptions.Item label="SGST">{printRupee(gst.sgst_amount)}</Descriptions.Item>
                    <Descriptions.Item label="IGST">{printRupee(gst.igst_amount)}</Descriptions.Item>
                    <Descriptions.Item label="CESS">{printRupee(gst.cess_amount)}</Descriptions.Item>
                    <Descriptions.Item label="Payment Initiated By">
                        {["paid", "Paid"].includes(gst.status) && gst.current_payment_attempt ?
                            (gst.current_payment_attempt.payment_initiated_by ? gst.current_payment_attempt.payment_initiated_by.name : <Text4 style={{ fontStyle: "italic" }}>Not Initiated</Text4>)
                            : <Text4 style={{ fontStyle: "italic" }}>Not Initiated</Text4>}
                    </Descriptions.Item>
                    <Descriptions.Item label="Payment Attempts">
                        <Button className="mr-2 pl-0" onClick={togglePaymentAttemptsDrawer} type="link" > View Payment Attempts </Button>
                    </Descriptions.Item>
                </Descriptions>
            </div>
        )
    }

    const renderApproval = () => {
        return (
            <div className="mt-4">
                <Text3 className="d-block" strong>Approvals</Text3>
                {
                    gst.current_challan_approval ?
                        <Descriptions className='mt-2' title={false} column={1} bordered size="small">
                            <Descriptions.Item label="Checked By">{gst.current_challan_approval.checker ? gst.current_challan_approval.checker.name : '--'}</Descriptions.Item>
                            <Descriptions.Item label="Approved By">{gst.current_challan_approval.approver ? gst.current_challan_approval.approver.name : '--'}</Descriptions.Item>
                        </Descriptions>
                        : <Text4 style={{ fontStyle: 'italic' }}>Approval flow is disabled for this challan.</Text4>
                }
            </div>
        )
    }

    const processPaymentButton = () => {
        return (
            <Descriptions.Item label="Action">
                <PayNowButton loading={isPaying} onClick={() => processPayment(gst.source_account.uuid)} type='primary' disabled={gst.status === "processing"}><><span className="mr-2" dangerouslySetInnerHTML={{ __html: `&#8377;` }} />{gst.status === "processing" ? "Payment in process" : "Pay Now"}</></PayNowButton>
            </Descriptions.Item>
        )
    }

    const SourceAccountButtom = () => {
        return (
            <Descriptions.Item label="Action">
                <PayNowButton loading={isPaying} onClick={() => toggleVirtualAccountModal()} type='primary' disabled={gst.status === "processing"}><><span className="mr-2" dangerouslySetInnerHTML={{ __html: `&#8377;` }} />{gst.status === "processing" ? "Payment in process" : "Pay Now"}</></PayNowButton>
            </Descriptions.Item>
        )
    }
    const renderPaymentButton = () => {
        return (
            <div className="mt-4">

                {
                    ["unpaid", "Unpaid", "unapproved", "Unapproved"].includes(gst.status) ? (
                        <Descriptions className='mt-0' title={false} column={1} bordered size="small">
                            <Descriptions.Item label="Payment Status">
                                {gst.status ? <Badge
                                    color={STATUSTYPES[gst.status.toLowerCase()].color}
                                    text={<Text4>{STATUSTYPES[gst.status.toLowerCase()].label}</Text4>}
                                /> : null}
                            </Descriptions.Item>
                            <Descriptions.Item label="Source Account">
                                {gst.source_account ? <> {gst.source_account.funding_via == 1 ? gst.source_account.virtual_account_number : "Credit Card Account"}
                                    {["unpaid", "Unpaid", "unapproved", "Unapproved"].includes(gst.status) ?
                                        <Button type="link" style={{ paddingLeft: 10 }} onClick={() => toggleVirtualAccountModal(true)}>Change</Button> : null}</>
                                    : <Text4 style={{ fontStyle: "italic" }}>Not Selected</Text4>}
                            </Descriptions.Item>
                            {
                                (
                                    gst.current_challan_approval ?
                                        <>
                                            {gst.current_challan_approval.approver && gst.current_challan_approval.checker && gst.status != "paid" ?
                                                processPaymentButton() :
                                                (
                                                    ((user.role == 3 && !gst.current_challan_approval.approver) || user.role == 2 && !gst.current_challan_approval.checker) ?
                                                        <Descriptions.Item label="Action">
                                                            <ApproveButton loading={isPaying} onClick={approvePayment} type='primary'><><span className="mr-2" />{"Approve"}</></ApproveButton>
                                                        </Descriptions.Item>
                                                        : null
                                                )
                                            }

                                        </>
                                        : (["unpaid", "Unpaid"].includes(gst.status) && (user.role || user.is_admin) ?
                                            (!gst.source_account ? SourceAccountButtom() : processPaymentButton())
                                            : null)
                                )
                            }
                        </Descriptions>
                    ) : null
                }
                {
                    gst.status === "paid" || gst.status === "Paid" ? (
                        <Alert
                            message={gst.status === 'Paid' || gst.status === "paid" ? 'Challan Paid Successfully' : 'Challan Payment In Process'}
                            description={gst.status === 'Paid' || gst.status === "paid" ? <>Challan has been paid successfully. <PermissableButton required_permission="GST_CHALLAN_WRITE" loading={isDownloading} className="pr-0" onClick={downloadAdvice} type='link'>Download Advice</PermissableButton></> : <>Challan payment is in process. We will inform you once the payment is successful.</>}
                            type={gst.status === 'Paid' || gst.status === "paid" ? 'success' : 'info'}
                            showIcon
                        />
                    ) : null
                }
            </div>
        )
    }

    return (
        <EaseDrawer
            className="payout-link-details-drawer"
            visible={props.visible}
            onClose={props.onClose}
            hideHeader
            hideFooter
            width={525}
        >
            <div className="mt-3">
                {renderTitle()}
                {renderBasicDetails()}
                {renderPaymentDetails()}
                {renderApproval()}
                {renderPaymentButton()}
                <AccountModal
                    visible={showVirtualAccountModal}
                    toggleVirtualAccountModal={toggleVirtualAccountModal}
                    virtualAccounts={props.user.virtual_accounts}
                    onSubmit={processPayment}
                    fetchChallanList={props.fetchChallanList}
                    loading={isPaying}
                    gst={{ ...gst }}
                    isUpdatingSA={isUpdatingSA}
                    user={props.user}
                />
                <PaymentAttemptsDrawer
                    togglePaymentAttemptsDrawer={togglePaymentAttemptsDrawer}
                    visible={showPaymentAttemptsDrawer}
                    onClose={() => togglePaymentAttemptsDrawer()}
                    gst={gst}
                />
            </div>
        </EaseDrawer>
    )
};

const mapStateToProps = (state) => ({
    current_user: state.userReducer.current_user,
});

const GSTDetails = connect(mapStateToProps, null)(GSTDetailsRdx);


export { GSTDetails };